import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Marquee from "../components/Marquee";
import Hero from "../sections/Hero";
import FeaturedCover from "../sections/FeaturedCover";
import ArticleGrid from "../sections/ArticleGrid";
import AsSeenIn from "../sections/AsSeenIn";
import Highlights from "../sections/Highlights";
import PullQuoteSection from "../sections/PullQuoteSection";
import BrandStatement from "../sections/BrandStatement";
import ContactCTA from "../sections/ContactCTA";
import { useSiteData } from "../context/SiteDataContext";
import { getSection } from "../lib/sectionStyles";

const orderedSections = [
  { key: "home.hero", component: <Hero /> },
  { key: "home.featured-cover", component: <FeaturedCover /> },
  { key: "home.article-grid-intro", component: <ArticleGrid /> },
  { key: "global.publications", page: "global", component: <AsSeenIn /> },
  { key: "home.public-proof", component: <Highlights /> },
  { key: "home.pull-quotes", component: <PullQuoteSection /> },
  { key: "home.writing-beats", component: <BrandStatement /> },
  { key: "home.contact", component: <ContactCTA /> },
];

const Home = () => {
  const { writer, siteSections } = useSiteData();
  const marqueeItems = [
    writer.issue,
    "WRITER & JOURNALIST",
    "COVER STORIES",
    "MUSIC",
    "FASHION",
    "ARTS & CULTURE",
    "CAIRO <-> WORLDWIDE",
    "MAI EL MOKADEM",
  ];
  const visibleSections = orderedSections
    .map((item, index) => ({
      ...item,
      section: getSection(siteSections, item.page || "home", item.key, { sortOrder: index * 10 }),
      index,
    }))
    .filter((item) => item.section)
    .sort((a, b) => (a.section.sortOrder || a.index * 10) - (b.section.sortOrder || b.index * 10));

  return (
    <div className="min-h-screen">
      <Marquee items={marqueeItems} accent />
      <Header />
      <main>
        {visibleSections.map((item) => (
          <React.Fragment key={item.key}>{item.component}</React.Fragment>
        ))}
      </main>
      <Footer />
    </div>
  );
};

export default Home;
